import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["d", "stroke", "stroke-width", "stroke-dasharray"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.outline)
    ? (_openBlock(), _createElementBlock("svg", {
        key: 0,
        class: "image-polygon-outline",
        overflow: "visible",
        width: _ctx.width,
        height: _ctx.height
      }, [
        _createElementVNode("path", {
          "vector-effect": "non-scaling-stroke",
          "stroke-linecap": "butt",
          "stroke-miterlimit": "8",
          "stroke-linejoin": "",
          fill: "transparent",
          d: _ctx.createPath(_ctx.width, _ctx.height),
          stroke: _ctx.outlineColor,
          "stroke-width": _ctx.outlineWidth,
          "stroke-dasharray": _ctx.outlineStyle === 'dashed' ? '10 6' : '0 0'
        }, null, 8, _hoisted_2)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}